import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["autoComplete", "label"];
import { styled, TextField, theme as themeValues } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { useField } from 'formik';
import uniqueId from 'lodash.uniqueid';
import { useEffect, useState } from 'react';
import { flushSync } from 'react-dom';
import { InputErrorIcon } from './InputErrorIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var InputRoot = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    marginBottom: theme.spacing(4),
    position: 'relative'
  };
});
var InputTextField = styled(TextField)({
  height: 38,
  width: '100%'
});
var InputFieldInfo = styled('div')({
  display: 'flex',
  position: 'absolute',
  right: 0,
  top: '50%'
});
export var Input = function Input(_ref2) {
  var autoComplete = _ref2.autoComplete,
      label = _ref2.label,
      props = _objectWithoutProperties(_ref2, _excluded);

  var _useField = useField(props),
      _useField2 = _slicedToArray(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helpers = _useField2[2];

  var _useState = useState(uniqueId('input-')),
      _useState2 = _slicedToArray(_useState, 1),
      id = _useState2[0];

  var name = field.name,
      value = field.value,
      onBlur = field.onBlur,
      onChange = field.onChange;
  var setValue = helpers.setValue;
  var type = props.type,
      defaultValue = props.defaultValue;

  var _useTestId = useTestId(),
      getTestId = _useTestId.getTestId;

  var isError = Boolean(meta.error && meta.touched);
  var fieldValue = value !== null && value !== void 0 ? value : defaultValue;
  useEffect(function () {
    if (defaultValue && (value === '' || value === undefined) && defaultValue !== value) {
      flushSync(function () {
        return setValue(defaultValue);
      });
    }
  }, [defaultValue, value, setValue]);
  return /*#__PURE__*/_jsxs(InputRoot, {
    children: [/*#__PURE__*/_jsx(InputTextField, {
      InputLabelProps: {
        shrink: true
      },
      error: isError,
      id: id,
      inputProps: {
        'data-testid': getTestId("input-".concat(name.toLowerCase())),
        autoComplete: autoComplete
      },
      label: label,
      name: name,
      type: type,
      value: fieldValue,
      variant: "standard",
      sx: {
        '& .MuiInputBase-root::before': {
          borderBottom: "1px solid ".concat(themeValues.palette.grey[300])
        }
      },
      onBlur: onBlur,
      onChange: onChange
    }), /*#__PURE__*/_jsx(InputFieldInfo, {
      "data-testid": getTestId("input-info-".concat(name.toLowerCase())),
      children: isError && /*#__PURE__*/_jsx(InputErrorIcon, {
        error: String(meta.error),
        "data-testid": getTestId("input-info-error-icon")
      })
    })]
  });
};